import { styled } from '@mui/system';

export const Main = styled('main')`
  position: relative;
  padding: 16px 32px;
  display: grid;
  gap: 16px;
`;